import { AuthOtpActions, AuthOtpActionTypes } from '../actions/auth-otp.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: null
};


export interface CheckAuthOTPState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialCheckAuthOTPState: CheckAuthOTPState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export const initialEnableAuthOTPState: EnableAuthOTPState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface EnableAuthOTPState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export function reducer(
  state = initialState,
  action: AuthOtpActions
): State {
  switch (action.type) {
    case AuthOtpActionTypes.AddAuthOtp: {
      return {...state, Loaded: false, Loading: true};
    }

    case AuthOtpActionTypes.AddAuthOtpSuccess: {
      return {...state, Loaded: true, Loading: false, entities: action.payload };
    }

    case AuthOtpActionTypes.AddAuthOtpFail: {
      return {...state, Loaded: true, Loading: false, entities: action.payload };
    }

    default: {
      return state;
    }
  }
}

export function checkAuthOTPreducer(
  state: CheckAuthOTPState = initialCheckAuthOTPState, action: AuthOtpActions
): CheckAuthOTPState {
  switch (action.type) {

    case AuthOtpActionTypes.CheckAuthOtp: {
      return {...state, Loaded: false, Loading: true};
    }

    case AuthOtpActionTypes.CheckAuthOtpSuccess: {
      return {...state, Loaded: true, Loading: false, entities: action.payload };
    }

    case AuthOtpActionTypes.CheckAuthOtpFail: {
      return {...state, Loaded: true, Loading: false, entities: action.payload };
    }

    default: {
      return state;
    }
  }
}

export function enableAuthOTPreducer(
  state: EnableAuthOTPState = initialEnableAuthOTPState, action: AuthOtpActions
): EnableAuthOTPState {
  switch (action.type) {

    case AuthOtpActionTypes.EnableAuthOtp: {
      return {...state, Loaded: false, Loading: true};
    }

    case AuthOtpActionTypes.EnableAuthOtpSuccess: {
      return {...state, Loaded: true, Loading: false, entities: action.payload };
    }

    case AuthOtpActionTypes.EnableAuthOtpFail: {
      return {...state, Loaded: false, Loading: false };
    }

    default: {
      return state;
    }
  }
}

export const getCheckAuthOtpState = (state: CheckAuthOTPState) => state;
export const getEnableAuthOtpState = (state: EnableAuthOTPState) => state;
